import {Component, DestroyRef, inject, signal, ViewChild} from '@angular/core';
import {TreeViewComponent} from '@syncfusion/ej2-angular-navigations/public_api';
import {RichTextEditor} from '@syncfusion/ej2-angular-richtexteditor/public_api';
import {ObjektModels} from '../../models/objekt-models';
import {ObjektDataService} from '../../services/objekt-data.service';
import {DatumFormatPipe} from '../../pipes/datum-format.pipe';
import {MatTableDataSource} from '@angular/material/table';
import {SwissSettingsService} from '../../services/swiss-settings.service';
import {MessageBoxService} from '../../services/message-box.service';
import {DokumentDataService} from '../../services/dokument-data.service';
import {BehaviorSubject, ReplaySubject, Subject, tap} from 'rxjs';
import {UserAuthenticationService} from 'src/app/services/user-authentication.service';
import {HelperService} from 'src/app/services/helper.service';
import {BenutzerModels} from 'src/app/models/benutzer-models';
import {TreeviewService} from '../../services/treeview.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';


@Component({
    template: ''
})

export abstract class ObjekteBaseComponent {
    @ViewChild('treeObjekte') treeView?: TreeViewComponent;
    @ViewChild('treeObjekteBottomUp') treeViewBottomUp?: TreeViewComponent;
    @ViewChild('treeObjekteTopDown') treeViewTopDown?: TreeViewComponent;
    @ViewChild('richTxtEditor1') rteObj1?: RichTextEditor;
    @ViewChild('richTxtEditor2') rteObj2?: RichTextEditor;

    //treeViewItems: Array<TreeViewItemsResponseObject> = [];
    currObjekt: ObjektModels.ObjektElement = ObjektModels.EmptyObjektElement();

    dataSourceObjektAdressen: MatTableDataSource<ObjektModels.ObjektAdresse> = new MatTableDataSource<ObjektModels.ObjektAdresse>();
    dataSourceObjektAktivitaeten: MatTableDataSource<ObjektModels.ObjektAktivitaetListElement> = new MatTableDataSource<ObjektModels.ObjektAktivitaetListElement>();
    hasObjektPartner: number = 0; // 0: nein | 1: ja
    hasObjektDokus: number = 0; // 0: nein | 1: ja
    objektAktivitaeten: ObjektModels.ObjektAktivitaetListElement[] = [];

    public field: Object = {
        dataSource: [], //this.treeViewItems,
        id: 'id',
        parentID: 'pid',
        text: 'name',
        hasChildren: 'hasChild',
        expanded: 'expanded',
        imageUrl: 'imageURL',
    };


    // Berechtigungen
    public rechtObjektLoeschen: boolean = false;
    public rechtObjektMutieren: boolean = false;
    public rechtObjektErstellen: boolean = false;
    public rechtObjektLiegenschaftErstellen: boolean = false;
    public rechtObjektAuftragErstellen: boolean = false;
    public rechtObjektOrdnerErstellen: boolean = false;
    public rechtObjektProdAuftragErstellen: boolean = false;
    public rechtObjektLieferantErstellen: boolean = false;
    public rechtObjektMitarbeiterErstellen: boolean = false;


    /* Expand-Status */
    expandStateObjektDetails: number = 1; // 0 = offen | 1 = geschlossen
    expandStateObjektErweiterung: number = 1; // geschlossen
    expandStateObjektAktivitaeten: number = 1; // geschlossen
    expandStateObjektAdressen: number = 1; // geschlossen
    expandStateObjektDokuInfos: number = 1; // geschlossen
    expandStateObjektStruktur: number = 1; // geschlossen

    dataSubject = new Subject<{ data: any[], online: boolean }>();
    dataSubject2 = new Subject<{ data: any[], online: boolean }>();
    objekte: any[] = [];
    protected destroyRef = inject(DestroyRef);
    protected awaitingAnswer: boolean = false;

    protected objectSelected$: BehaviorSubject<string> = new BehaviorSubject('');
    // TODO remove in 2.18.290 https://swissjira.atlassian.net/browse/EN-4409
    protected partialTreeMode$: BehaviorSubject<boolean> = new BehaviorSubject(true);
    protected showStatusColorInTree = signal(false);
    protected treeData$: ReplaySubject<any> = new ReplaySubject(1);
    protected currentHeadNodeID = '';

    protected constructor(public svcObjekte: ObjektDataService, public _datumFormatPipe: DatumFormatPipe, public userAuthService: UserAuthenticationService, public swissSettings: SwissSettingsService, public svcDokuData: DokumentDataService, public svcMessageBox: MessageBoxService, public helperService: HelperService, public treeviewCache: TreeviewService) {
        this.helperService.getOnlineStateChanged().pipe(takeUntilDestroyed()).subscribe({
            next: () => {
                this.refreshTreByOnlineStatus();
            }
        });
        this.swissSettings.getSwissAppUserConfig$().pipe(
            takeUntilDestroyed(),
            tap((user) => {
                this.showStatusColorInTree.set(user?.showObjectStatusColorInTree || false);
            })
        ).subscribe();
    }

    refreshTreByOnlineStatus() {
        this.partialTreeMode$.next(true);
        this.refreshObjektBaum();

        if (!this.helperService.isWebServiceAvailable()) {
            this.refreshOfflineSuchfeldBeschreibungen();
        } else {
            this.refreshSuchfeldBeschreibungen();
        }
    }

    refreshSuchfeldBeschreibungen() {
        this.svcObjekte.getSuchfeldBeschreibungen().subscribe({
            next: async (res) => {
                await this.svcObjekte.saveSuchfeldBeschreibungen(res);
            },
        });
    }

    refreshOfflineSuchfeldBeschreibungen() {
        this.svcObjekte.getOfflineSuchfeldBeschreibungen().then((value) => {
            this.objekte = value;
        });
    }

    initUserRights() {
        this.rechtObjektMutieren = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteMutieren);
        this.rechtObjektLoeschen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteLoeschen);
        this.rechtObjektLiegenschaftErstellen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteLiegenschaftErstellen);
        this.rechtObjektAuftragErstellen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteAuftragErstellen);
        this.rechtObjektOrdnerErstellen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteOrdnerErstellen);
        this.rechtObjektProdAuftragErstellen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteProdAuftragErstellen);
        this.rechtObjektLieferantErstellen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteLieferantErstellen);
        this.rechtObjektMitarbeiterErstellen = this.userAuthService.getRight(BenutzerModels.UserRightCodes.ObjekteMitarbeiterErstellen);

        // Es darf auch nur ein Objekt erstellt werden, wenn mindestens auf ein Objekt-Typ das Recht vorhanden ist
        this.rechtObjektErstellen = this.rechtObjektLiegenschaftErstellen || this.rechtObjektOrdnerErstellen || this.rechtObjektLieferantErstellen || this.rechtObjektMitarbeiterErstellen;
    }

    formatDate(datum: Date): string {
        // Formatiert das Datum in das Format "dd.MM.yyy HH.mm.ss"
        return this._datumFormatPipe.transform(datum);
    }

    reloadObjektAdressen(): Promise<ObjektModels.ObjektAdresse[]> {
        return new Promise((resolve) => {
            if (this.helperService.isWebServiceAvailable()) {
                // Ansprechspartner der aktuellen Adresse laden
                this.svcObjekte.getAddressesByObjektID(this.currObjekt.objectID).subscribe({
                    next: (res: ObjektModels.ObjektAdresse[]) => {
                        this.dataSourceObjektAdressen!.data = res;
                        this.hasObjektPartner = 0;
                        if (this.dataSourceObjektAdressen.data.length > 0) {
                            this.hasObjektPartner = 1;
                        }
                        resolve(res);
                    },
                });
            } else {
                this.svcObjekte.getOfflineAddressesByObjektID(this.currObjekt.objectID).then((res) => {
                    this.dataSourceObjektAdressen!.data = res;
                    this.hasObjektPartner = 0;
                    if (this.dataSourceObjektAdressen.data.length > 0) {
                        this.hasObjektPartner = 1;
                    }
                    resolve(res);
                });
            }
        });

    }

    reloadObjektAktivitaeten(): Promise<boolean> {
        return new Promise((resolve) => {
            if (this.helperService.isWebServiceAvailable()) {

                // Objektaktivitäten des aktuellen Objekts laden
                this.svcObjekte.getObjectActivities(this.currObjekt.objectID).subscribe({
                    next: (res: ObjektModels.ObjektAktivitaetListElement[]) => {
                        this.objektAktivitaeten = res;

                        this.dataSourceObjektAktivitaeten!.data = res;
                        this.hasObjektDokus = 0;
                        if (this.dataSourceObjektAktivitaeten.data.length > 0) {
                            this.hasObjektDokus = 1;
                        }

                        if (this.hasObjektDokus) {
                            this.setExpandStateObjektAktivitaeten(0);
                        } else {
                            this.setExpandStateObjektAktivitaeten(1);
                        }

                        resolve(true);
                    },
                });
            } else {
                this.svcDokuData.getOfflineObjectActivities(this.currObjekt.objectID).then((res) => {
                    this.objektAktivitaeten = res;
                    this.dataSourceObjektAktivitaeten!.data = res;
                    this.hasObjektDokus = 0;
                    if (this.dataSourceObjektAktivitaeten.data.length > 0) {
                        this.hasObjektDokus = 1;
                    }

                    if (this.hasObjektDokus) {
                        this.setExpandStateObjektDokuInfos(0);
                    } else {
                        this.setExpandStateObjektDokuInfos(1);
                    }


                    resolve(true);
                });
            }
        });
    }

    reloadObjektBerechtigungen(): Promise<boolean> {
        return new Promise((resolve) => {
            this.initUserRights();
            // Hier müssen die Benutzerberechtigungen geladen werden, sofern ein Betriebsteil dem Objekt zugeordnet ist
            if (this.currObjekt.fk_CompanypartID) {
                this.userAuthService.getUserObjectRights(this.currObjekt.objectID).then(userRights => {
                    // Recht: Objekt löschen
                    // Wenn der Benutzer grundsätzlich löschen darf, dann müssen die Betriebsteil-Berechtigungen geprüft werden
                    // Darf er das auf dem Betriebsteil nicht, dann müssen die Objektberechtigungen überschrieben werden.
                    let rechtLoeschen = userRights.find((x) => x.rightsID === 3);
                    if (rechtLoeschen) {
                        this.rechtObjektLoeschen = (rechtLoeschen.effectiveValue === -1);
                    }
                    resolve(true);
                }).catch(() => {
                    resolve(false);
                });
            }
            resolve(true);
        });
    }

    refreshObjektBaum(): Promise<boolean> {
        return new Promise((resolve) => {
            if (this.helperService.isWebServiceAvailable() && navigator.onLine) {
                const treeviewData = this.treeviewCache.getData()!;
                if (treeviewData) {
                    this.treeviewCache.reloadFromCache();
                    resolve(true);
                } else {
                    if (this.partialTreeMode$.getValue()) {
                        this.treeviewCache.updateData();
                    }
                }
            } else {
                resolve(this.refreshOfflineObjektBaum());
            }
        });
    }

    async refreshOfflineObjektBaum(): Promise<boolean> {
        const res = await this.svcObjekte.getOfflineObjektBaum();
        if (!this.dataSubject.closed) {
            this.dataSubject.next({data: res, online: false});
        }
        if (!this.dataSubject2.closed) {
            this.dataSubject2.next({data: res, online: false});
        }
        return true;
    }


    setExpandStateObjektDetails(index: number) {
        this.expandStateObjektDetails = index;
    }

    setExpandStateObjektErweiterung(index: number) {
        this.expandStateObjektErweiterung = index;
    }

    setExpandStateObjektAktivitaeten(index: number) {
        this.expandStateObjektAktivitaeten = index;
    }

    setExpandStateObjektAdressen(index: number) {
        this.expandStateObjektAdressen = index;
    }

    setExpandStateObjektDokuInfos(index: number) {
        this.expandStateObjektDokuInfos = index;
    }

    setExpandStateObjektStruktur(index: number) {
        this.expandStateObjektStruktur = index;
    }


    downloadDocument(element: ObjektModels.ObjektAktivitaetListElement) {
        var docID = element.id;
        // Hier wird der Dateiname anhand der DocumentID ermittelt
        let listEntry = this.objektAktivitaeten.filter((doc) => doc.id === docID)[0];

        var fileName = listEntry.documentName;

        // Wenn es sich um eine s3a-Datei handelt, muss die Dateierweiterung auf pdf geändert werden.
        // Beispiel: test.s3a wird zu test.pdf
        var fileExtension = fileName.substring(fileName.lastIndexOf('.'));
        if (fileExtension.toLowerCase() == '.s3a') {
            fileName = fileName.substring(0, fileName.lastIndexOf('.')) + '.pdf';
        }
        if (fileName.substring(fileName.lastIndexOf('.')) == '.pdf') {
            fileName = element.description ? element.description + '.pdf' : fileName;
        }

        if (this.helperService.isWebServiceAvailable()) {
            this.svcDokuData.downloadDocument(docID, fileName);
        } else {
            this.svcDokuData.openLocalDocument(docID, true, fileName);
        }
    }

}

export enum ObjectDataType {
    Objekt = '1', // Liegenschaft / Ordner / Lieferant / Mitarbeiter / Kunde
    Auftrag = '2',
    ProdAuftrag = '3',
}

// Betrifft das Feld Art in ObjectActivities_PQ.spx Param = 1
export enum ObjectActivityType {
    Dokument = 1,
    Aufgabe = 2,
    Termin = 4,
    Notiz = 8,
    Bild = 12,
    Notizblatt = 16,
    ObjektReport = 18
}
